import CustomSteps from './CustomSteps'
import CustomStepItem from './CustomStepItem'

CustomSteps.StepItem = CustomStepItem

export default CustomSteps